import PropTypes from 'prop-types';
import React from 'react';
import { Flex } from 'rebass';

const UserBox = ({ children }) => (
  <Flex
    backgroundColor="secondary"
    style={{ borderRadius: 100, width: 'fit-content' }}
    padding={2}
    paddingY={1}
    alignItems="center"
    mb="-6px"
  >
    {children}
  </Flex>
);

UserBox.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserBox;
